import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { TOOLTIP_DEFAULT_WIDTH } from '../common/components/PositionedTooltip/constants';

export type HoveredItemType = {
  id: string;
  index: number;
  name: string;
  tooltipXCoordinate: number;
  tooltipYCoordinate: number;
  value: number;
  x: Date;
  color?: string;
};

export type HoveredEventType = {
  level: string;
  description: string;
  tooltipXCoordinate: number;
  tooltipYCoordinate: number;
  value: number;
  x: Date;
  color: string;
};

export type TooltipInitialState = {
  hoveredItem: HoveredItemType | null;
  hoveredEventData: HoveredEventType | null;
  isVisible: boolean;
  arrowOffset: string;
  activeTooltipWidth: number;
};

export const initialState: TooltipInitialState = {
  hoveredItem: null,
  hoveredEventData: null,
  isVisible: false,
  arrowOffset: '50%',
  activeTooltipWidth: TOOLTIP_DEFAULT_WIDTH,
};

export const tooltipSlice = createSlice({
  name: 'tooltip',
  initialState,
  reducers: {
    setHoveredItem: (
      state,
      { payload }: PayloadAction<HoveredItemType | null>,
    ) => {
      state.hoveredItem = payload;
    },
    setHoveredEventData: (
      state,
      { payload }: PayloadAction<HoveredEventType | null>,
    ) => {
      state.hoveredEventData = payload;
    },
    setTooltipArrowOffset: (state, action: PayloadAction<string>) => {
      state.arrowOffset = action.payload;
    },
    setActiveTooltipWidth: (state, action: PayloadAction<number>) => {
      state.activeTooltipWidth = action.payload;
    },
  },
});

export const {
  setHoveredItem,
  setHoveredEventData,
  setTooltipArrowOffset,
  setActiveTooltipWidth,
} = tooltipSlice.actions;

export const tooltipSelectors = {
  selectHoveredItem: (state: RootState) => state.tooltip.hoveredItem,
  selectHoveredEventData: (state: RootState) => state.tooltip.hoveredEventData,
  selectTooltipArrowOffset: (state: RootState) => state.tooltip.arrowOffset,
  selectTooltipActiveTooltipWidth: (state: RootState) =>
    state.tooltip.activeTooltipWidth,
};

export default tooltipSlice.reducer;
